import React from 'react'
import {
  Button,
  Box
} from '@mui/material'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import { useSnackbar } from 'notistack'
import TextInput from 'components/atoms/textInput'
import validateEmail from './validateEmail'
import { resetPassword } from 'api'

const ResetFormView = () => {
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()
  const navigate = useNavigate()
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
    clearErrors,
    reset  // Add reset function from useForm
  } = useForm({
    resolver: yupResolver(validateEmail),
  })

  const handleFormSubmit = async (data) => {
    try {
      const response = await resetPassword(data);
      if (response?.message === 'email_not_found') {
        setError('email', {
          type: 'manual',
          message: t('reset.emailNotFound')
        });
      }
      else if (response?.message === 'email_sent') {
        // Clear any previous errors
        clearErrors('email');
        
        // Reset the form
        reset();
        
        // Show success message in snackbar
        enqueueSnackbar(t('reset.success'), {
          variant: 'success',
        });
        
        // Optional: You could also navigate away or show a confirmation component
        // setTimeout(() => navigate('/login'), 3000);
      }
      else {
        setError('email', {
          type: 'manual',
          message: t('reset.emailNotFound')
        });
      }
    } catch {
      setError('email', {
        type: 'manual',
        message: t('reset.generalError')
      });
    }
  }

  return (
    <Box
      component="form"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 2
      }}
    >
      <TextInput
        label={t('login.emailLabel')}
        name='email'
        control={control}
        error={errors?.email}
        helperText={
          errors?.email?.type === 'success'
            ? errors.email.message
            : errors?.email?.message
        }
        // Optional: change color for success state
        sx={{
          '& .MuiFormHelperText-root': {
            color: errors?.email?.type === 'success'
              ? 'success.main'
              : 'error.main'
          }
        }}
      />
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <Button
          variant="text"
          color="primary"
          onClick={() => navigate('/login')}
          sx={{ textTransform: 'none' }}
        >
          {t('reset.backLogin')}
        </Button>
        <Button
          variant='contained'
          color='primary'
          onClick={handleSubmit(handleFormSubmit)}
        >
          {t('reset.reset')}
        </Button>
      </Box>
    </Box>
  )
}

export default ResetFormView